module.exports = __webpack_public_path__ + "static/media/privacy.1b58a0ac.svg";